module.exports={
  message: {
    "Online Magazine": 'Magazine',
    "Browse Occupations":'Careers',
    "Find An Opportunity":"Find An Opportunity",
    "Qualifications":"Qualifications",
    "Self Assessment":"Self Assessment",
    "Home":"Home",
    "Job detail":"Job detail",
    "Browse Courses":"Courses",
    "Year":"Year",
    "Month":"Month",
    "Day":"Day",
    "monthsAgo":" Months ago",
    "weeksAgo":" Weeks ago",
    "daysAgo":" Days ago",
    "dayAgo":" Day ago",
    "today":" Today",
    "OccupationTitleSkillOrIndustry":"Occupation title, skill or industry",
    "All Education Level":"All Education Level",

    "Requirement":"Requirement",
    "Experience":"Experience",
    "EducationLevel":"Education Level",
    "Skills":"Skills",
    "outLook":"Outlook",
    "CareerPath":"Career Path",
    "Common Skills":"Common Skills",
    "Growing Skills":"Growing Skills",
    "Manpoweroutlook":"Projected demand",
    "Automationpotential":"Automation potential",
    "Private Sector":"Private Sector",
    "Government Sector":"Government Sector",
    "To know more":"To know more",
    "Share with":"Share with",
    "RelatedJobOpportunities":"Related Vacancies",
    "Opportunities":"Opportunities",
    "RelatedCourses":"Related Courses",
    "QR Courses":"QR Courses",
    "MOOC Courses":"MOOC Courses",
    "View all opportunities":"View all",
    "View all qualifications":"View all",
    "Related Job functions":"Related Job Functions:",
    "Discover career resources for educators and employers":"Explore training resources and learn more about career development",
    "link":"[link]",
    "forStart":'"',
    "for":'for ',
    "forEnd":'"',
    "Low":"Low",
    "High":"High",
    "Show more":"Show more",
    "Show less":"Show less",
    "Monthly salary":"Monthly salary",
    "All Job Functions":"All Job Functions",
    "Find a Job Opportunity":"Vacancies",
    "Career quizzes":"Career quizzes",
    "Hot Picks":"Hot Picks",
    "hotPicks":"Hot Picks",
    "Top 5 searches":"Top searches",
    "View all":"View all",
    "FInd out more":"Discover",
    "Stay":"Stay ahead of your career. Find your next job here.",
    "Job title, company name or skill, etc":"Job title, company name or skill, etc",
    "Job Functions":"Job Functions",
    "Search":"Search",
    "Learning and Upskilling":"Learning and Upskilling",
    "Learn from":"Learn from the best. Discover thousands of full time, part time and online courses.",

    "What careers would suit you?":"What careers would suit you?",
    "Various career":"Various career quizzes here can help you explore career pathways and develop insights into career decision-making based on your interests and talents",
    "Take a quiz":"Take a quiz",
    "Resources":"Resources",
    "Feedback":"Feedback",
    "About Human":"About Human Resources Planning Commission",
    "About Us":"About Us",
    "Privacy Policy":"Privacy Policy",
    "Disclaimer":"Disclaimer",
    "© 2019":" talent.gov.hk. All rights reserved.",
    "Self-Assessment":"Quizzes",
    "developmentTip":"This section is under development. Please ignore. ",
    "FT":"Full time",
    "PT":"Part time",
    "DL":"Distance learning",
    "EL":"Online/Mobile",
    "Not Applicable":"Not Applicable",
    "siteMap":"Site Map",
    "CourseInputTip":"Course title, Institution or skill, etc",
    "All Areas of Study":"All Areas of Study",
    "CEF":"CEF reimbursable courses",
    "All Learning Modes":"All Learning Modes",
    "All Course Providers":"All Course Providers",
    "Fewer Options":"Fewer Options",
    "More Options":"More Options",
    "results":" results",
    "item":"item",
    "QR number:":"QR number:",
    "Course Provider":"Course Provider",
    "Area of Study":"Area of Study",
    "Learning mode":"Learning Mode",
    "Level":"Level",
    "Pace of learning":"Pace of learning",
    "Effort":"Effort",
    "Length":"Length",
    "What youll learn":"What you'll learn",
    "Requirements":"Job requirements",
    "Prerequisites":"Prerequisites",
    "Go to course page":"Go to course page",
    "QR level 1-3":"Foundation certificate / diploma",
    "QR level 4":"Higher certificate / Higher Diploma / Associate Degree",
    "QR level 5":"Bachelor degree or equivalent",
    "QR level 6":"Postgraduate Certificate / Postgraduate Diploma / Master degree",
    "QR level 7":"Doctorate",
    "All Level of Positions":"All Level of Positions",
    "All Job Types":"All Job Types",
    "Organization":"Organization",
    "Job function(s)":"Job function(s)",
    "Department":"Department",
    "Level of position":"Level of position",
    "Salary":"Salary",
    "Job descriptions":"Job descriptions",
    "Job duties":"Job duties",
    "Advertising date":"Advertising date",
    "All Level":"All Course Levels",
    "Show more":"Show more",
    "Show less":"Show less",
    "Apply on":"Apply on",
    "Apply on2":"",
    "Apply":"Apply",
    "Other Job Opportunities":"Other Job Opportunities",
    "ViewAll":"View all",
    "jobTAndC":"talent.gov.hk contains job vacancies information from external sources and relevant links as a convenience to our users, and is not responsible for the content of these sites.",
    "EffortTip1":"",
    "EffortTip2":" hours/week",
    "week(s)":"week(s)",
    "noSearchResult":"There are no relevant results.",
    "Category":"Category",
    "Feature story":"Feature story",
    "Side story":"Side story ",
    "Column":"Column",
    "All":"All",
    "Careers Exploration":"Careers Exploration",
    "Vacancies Search":"Vacancies Search",
    "All articles":"All articles",
    "on this page":"What's on this page",
    "skillTips":"TIPS: Click on the skills to search for relevant courses.",
    "Relevant links":"Relevant Links",
    "assessmentDesc":"Various career quizzes here can help you explore career pathways and develop insights into career decision-making based on your interests and talents.",
    "Skill-Career Quiz":"Skill-Career Quiz",
    "Interest-Career Quiz":"Interest-Career Quiz",
    "Background-Career Quiz":"Background-Career Quiz",
    "getStarted":"Let's get started",
    "skillDesc":"Leverage your talents. This career quiz helps you quickly identify careers that are related to your strengths.",
    "skillContent1":"Tell us the skills and knowledge that you possess or are interested to acquire by answering simple questions.",
    "skillContent2":"We then identify careers in the database that match closest to your skill profile.  After the first six questions, the quiz will start returning a list of potential careers.  ",
    "skillContent3":"You may further explore the details by clicking into each suggested career.",
    "Start":"Start",
    "interestDesc1":"Learning about your interests, this career quiz can assist you to explore work you might like and find rewarding.",
    "interestDesc2":"This quiz adopts the ",
    "interestDesc3":"<a target='_blank' href='https://www.onetcenter.org/tools.html'>O*NET Mini Interest Profiler</a> ",
    "interestDesc4":".  It has 30 questions about your interests in work activities and identifies careers that match closest to your interests.",
    "interestDesc5":"After the first six questions, the quiz will start returning a list of potential careers that match your interests.  You may further explore the details by clicking into each suggested career anytime.",
    "interestDesc6":"Read each question carefully and decide how you would feel about doing each activity:",
    "Strongly Dislike":"Strongly Dislike",
    "Dislike":"Dislike",
    "Unsure":"Unsure",
    "Like":"Like",
    "Strongly Like":"Strongly Like",
    "interestDesc7":"Just think about if you would like or dislike doing the work.  Try NOT to think about whether you have enough education or training to do the work, or how much money you would make doing the work, etc.",
    "interestDesc8":"There are no right or wrong answers.Please take your time answering the questions. There is no need to rush!",
    "backgroundDesc":"Try this career quiz and get insights on careers that match your education and experience! ",
    "Q":"Q",
    "Your Career Matches":"Your Career Matches",
    "resultTip":"Results will be shown after answering 6 questions.",
    "Show result":"Show Results",
    "Your highest education attained:":"Your highest education attained: ",
    "Years of working experience:":"Your years of working experience:",
    "Your field of study:":"Your field of study:",
    "studyNote":"(Note: The field of study mostly refers to subject in your post-secondary education.  If you did not engage in any post-secondary education, you may choose one that you wish to study in the future.)",
    "Your current occupation:":"Your current occupation:",
    "NoMatchingResults":"No matching results.",
    "Issue":"Issue",
    "Number":"Number",
    "Years":"Years",
    "Field of study":"Field of study",
    "Job title":"Job title",
    "Try another quiz":"Try another quiz",
    "Log in Facebook to view comments":"Log in Facebook to view comments",
    "Feature Articles":"Feature Articles",
    "Columns":"Columns",
    "The Headline":"The Headline",
    "View Comments":"View Comments",
    "Read more:":"Read more:",
    "Recommended articles":"Recommended Articles",
    "Related Occupations":"Related Careers",
    "Published:":"Published:",
    "Select Issue":"Select Issue",
    "Feature articles":"Feature articles ",
    "feedbackDesc":"Thank you for vising talent.gov.hk! We welcome your feedback. Please complete and submit the below form (fields with asterisk (*) denote required fields).",
    "sendSuccess":"Your message was sent successfully. Thank you!",
    "Email":"Email",
    "Types of user":"Type of user",
    "Student":"Student",
    "Job seeker":"Job seeker",
    "Employee":"Employee",
    "Employer":"Employer",
    "CareerEducationCounsellor":"Career / education counsellor",
    "Others":"Others",
    "Age group":"Age group",
    "Below 18":"Below 18",
    "60 or above":"60 or above",
    "Type of feedback":"Type of feedback",
    "Enquiries":"Enquiries",
    "Outdated inaccurate information":"Outdated / inaccurate information",
    "Suggestions and recommendations":"Suggestions and recommendations",
    "Collaboration opportunities":"Collaboration opportunities",
    "Related Page":"Related page(s)",
    "Contact information":"Contact information",
    "Feedback form":"Feedback form",
    "Message":"Message",
    "Please enter message":"Please enter message",
    "Submit":"Submit",
    "Welcome Talent":"Welcome to talent.gov.hk",
    "Talent information":"talent.gov.hk is an information portal established by the Human Resources Planning Commission of the HKSAR Government, providing consolidated manpower information to facilitate the making of informed choices in respect of career, learning and development pathways.",
    'Explorer':'"Explorer" is a monthly online magazine under talent.gov.hk on trending topics in the job market.',
    "Membership and Terms of Reference":"HRPC Membership and Terms of Reference",
    "HRPC Information Centre":"HRPC Information Centre",
    "Press Release":"Press Release",
    "Archive":"Archive",
    "Contact Us":"Contact Us",  
    "Address":"Address",
    "Telephone number":"Telephone number",
    "Please enter your email":"Please enter your email",
    "Please select the type of user":"Please select type of user",
    "Please select the age group":"Please select age group",
    "Please select type of feedback":"Please select type of feedback",
    "Feature stories":"Feature Stories",
    "Human Resources Planning Commission":"Human Resources Planning Commission",
    "Email:":"E-mail: ",
    "Address:":"Address: ",
    "hrpc@cso.gov.hk":"hrpc@cso.gov.hk",
    "2810 2586":"2810 2586",
    "2537 7068":"2537 7068",
    "Human Resources":"Human Resources Planning Commission Secretariat 26/F, East Wing, Central Government Offices, Tim Mei Avenue 2, Admiralty, Hong Kong",
    "Telephone:":"Telephone: ",
    "Fax:":"Fax: ",
    "ReratedCourses":"Browse Courses",
    "Slide to view more":"Slide to view more",
    "CEF_text":'The Continuing Education Fund (CEF) subsidises adults with learning aspirations to pursue continuing education and training.  Only continuing education and training courses registered under CEF as "reimbursable courses" are reimbursable under CEF.  The application procedures and a list of the reimbursable courses can be obtained from the [link]',
    "CEF_link_text":"CEF website",
    "CEF_link":"https://www.wfsfaa.gov.hk/cef/en/index.htm",
    "QR_text":'The [link] is a register established by the Secretary for Education under the Accreditation of Academic and Vocational Qualifications Ordinance for entering qualifications recognised under the QF. The Hong Kong Council for Accreditation of Academic and Vocational Qualifications has been specified in the Ordinance as the authority for developing and maintaining the QR. ',
    "QR_link_text":"QR",
    "QR_link":"https://www.hkqr.gov.hk/HKQRPRD/web/hkqr-en/index.html",
    "MOOC_text":'Massive Open Online Course (MOOC) offered by edX.',
    "Copied link to clipboard":"Copied link to clipboard!",
    "Close":"Close",
    "Beta Version":"Beta Version",
    "Powered by":"Powered by",
    "QF level":"QF level ",
    "Discover more career resources":"Discover more career resources",
    "There are no":"There are no relevant results.",
    "description":"Explore over 20000 job vacancies from the government and major job boards, over 300 career profiles and more than 10000 courses to find your ideal career and learning pathways! About us: talent.gov.hk is an information portal established by the Human Resources Planning Commission of the HKSAR Government, providing consolidated manpower information to facilitate the making of informed choices in respect of career, learning and development pathways.",
    'mateMagezine':"Explorer - the magazine of Talent.gov.hk",
    "benefits":"Benefit",
    "location":"Location",
    "There are (number) jobs for you":"There are (number) jobs for you.",
    "Choose a job for more details!":"Click the listed jobs for more details!",
    "Explorer_talent":"Explorer magazine - talent.gov.hk - One-stop Manpower Information Portal",
    "Explorer_desc":'"Explorer" is an online magazine under talent.gov.hk on trending topics on careers, upskilling and the job market',
    "Explorer_title":"Explorer magazine",
    "Featured Jobs":"Hot Vacancies",
    "View all Featured Jobs":"View all",
    "View all Occupation":"View all",
    "Popular Courses":"Popular Courses",
    "View all Popular Courses":"View all",
    "Career Magazine": "Explorer Magazine",
    "Hot Occupations": "Hot Occupations", 
    "Discover": "Discover",
    "browseOccupations": "Career Exploration",
    "findJob": "Vacancies Search",
    "browseCouses": "Browse Courses",
    "careerQuizzes": "Career Quizzes",
    "browseOccupations_text": "Explore our 300+ occupation profiles to discover career possibilities.",
    "findJob_text": "Search for government or private sector jobs that suit you from our vacancies database.",
    "browseCouses_text": "Discover 10000+ courses to build your skills and qualifications.",
    "careerQuizzes_text": "Take our career quizzes to discover jobs matched to your interests, skill and experience.",
    "View all occupations": "View all",
    "View all findJob": "View all",
    "View all browseCouses": "View all",
    "View all careerQuizzes": "Take a quiz",
    "Let get started": "Learn more",
    "Discover Description": "Use our tools to discover your career pathways, learning options and job opportunities.",
    "Default Page Title": "One-stop Manpower Information Portal",
    "Careers_title":"Career Exploration",
    "Careers_desc":"Explore your ideal careers in this database introducing more than 300 occupations, including information on key tasks of the occupations, skill requirements, entry requirements and employment outlook, together with related job vacancies and courses",
    "Courses_desc":"Discover over 10000 learning and upskilling courses in our database on both local courses listed in the Qualifications Register and open online courses listed in an overseas education platform, with information on Continuing Education Fund (CEF) courses",
    "Courses_title": " - Courses - talent.gov.hk",
    "Job_desc": "Daily update over 20000+ job vacancies from the government and major job boards. Search now!",
    "Job_title": " - Vacancies -  talent.gov.hk",
    "Self-Assessment_title":"Career Quizzes",
    "Self-Assessment_desc":"Three career quizzes here can help you explore career pathways and develop insights into career decision-making based on your interests, talents, education and experience!",
    "Default Keywords": "hong kong jobs,jobs hk,career,jobs,salary,搵工,求職,招職,resume,cover letter,CV,find job",
    "Explorer_Keywords": "hong kong jobs,jobs hk,career,jobs,salary,搵工,求職,招職,resume,cover letter,CV,find job",
    "Careers_keywords": "hong kong jobs,jobs hk,career,jobs,salary,搵工,求職,招職,resume,cover letter,CV,find job",
    "Courses_keywords": "hong kong jobs,jobs hk,career,jobs,salary,搵工,求職,招職,resume,cover letter,CV,find job",
    "Job_keywords": "hong kong jobs,jobs hk,career,jobs,salary,搵工,求職,招職,resume,cover letter,CV,find job",
    "Self-Assessment_keywords": "hong kong jobs,jobs hk,career,jobs,salary,搵工,求職,招職,resume,cover letter,CV,find job",
    "View all QR Courses": "View all QR Courses",
    "View all MOOC Courses": "View all MOOC Courses",
    "Entry level": "Entry level",
    "Part time": "Part time",
    "Government vacancies": "Government vacancies",
    "Job Creation Scheme": "Job Creation Scheme",
    "Instant-filter": "Quick filter",
    "min":"min",
    "hour":"hour",
    "s":"s",
  }
}